import {
  unwrap,
  type PortalOnboardingCompletion,
  type PortalOnboardingStatus,
} from '@billda/api';
import { api } from '../../../shared/api/billdaApi';

export type OnboardingStatusResponse = PortalOnboardingStatus;
export type CompleteOnboardingResponse = PortalOnboardingCompletion;

export const getOnboardingStatus = async (
  signal?: AbortSignal
): Promise<OnboardingStatusResponse> =>
  unwrap(await api.portalGateway.GET('/portal/v1/onboarding', { signal }));

export const completeOnboarding =
  async (): Promise<CompleteOnboardingResponse> =>
    unwrap(await api.portalGateway.POST('/portal/v1/onboarding/complete'));
